import { render, staticRenderFns } from "./InterfacePositionWish.vue?vue&type=template&id=36d27ae5"
import script from "./InterfacePositionWish.vue?vue&type=script&lang=js"
export * from "./InterfacePositionWish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports